import { call, select, put } from 'redux-saga/effects';

import { RT } from '../../../../shared/types';
import { actions } from '../reducer';
import { teamsModel } from '../../../teams';
import { collaborationApi } from '../../../../shared/api';
import { pagesModel } from '../../../pages';
import { commentsModel } from '../index';
import { createNotification, snackbarModel } from '../../../snackbar';

export function* updateThreadStatus({
  payload: { threadId, resolved },
}: ReturnType<typeof actions.updateThreadStatus>) {
  const currentTeam: RT<
    typeof teamsModel.selectors.selectCurrentTeamWithError
  > = yield select(teamsModel.selectors.selectCurrentTeamWithError);
  const currentPage: RT<
    typeof pagesModel.selectors.selectCurrentPageWithError
  > = yield select(pagesModel.selectors.selectCurrentPageWithError);

  try {
    yield call(collaborationApi.updateThreadStatus, {
      pageId: currentPage.id,
      teamId: currentTeam.id,
      threadId,
      data: { resolved },
    });

    if (resolved) {
      const resolvedThreadIds: RT<
        typeof commentsModel.selectors.selectResolvedThreadIds
      > = yield select(commentsModel.selectors.selectResolvedThreadIds);
      yield put(
        commentsModel.actions.setResolvedThreadId([
          ...resolvedThreadIds,
          threadId,
        ])
      );
      yield put(commentsModel.actions.commentThreadResolved(threadId));
    }
  } catch (err) {
    snackbarModel.actions.addNotificationAction(
      createNotification(
        'error',
        `Failed to ${resolved ? 'resolved' : 'unresolved'} a comment`
      )
    );
  }
}
